import { extendTheme } from 'native-base';

const theme = extendTheme({
    colors: {
        // Add new color
        primary:
        // {
        //     '50': '#fafdfe', 
        //     '100': '#f5fcfd', 
        //     '200': '#e6f7f9', 
        //     '300': '#d6f1f5', 
        //     '400': '#b8e7ee', 
        //     '500': '#99dde6', 
        //     '600': '#8ac7cf', 
        //     '700': '#73a6ad', 
        //     '800': '#5c858a', 
        //     '900': '#4b6c71'
        // }        
        {
            '50': '#fff7f8', 
            '100': '#fef0f1', 
            '200': '#fed9dc', 
            '300': '#fdc1c7', 
            '400': '#fb939e', 
            '500': '#f96574', 
            '600': '#e05b68', 
            '700': '#bb4c57', 
            '800': '#953d46', 
            '900': '#7a3139'
        }
        ,
        secondary:
        {
            '50': '#fffcf2', 
            '100': '#fff9e6', 
            '200': '#fff0bf', 
            '300': '#ffe799', 
            '400': '#ffd54d', 
            '500': '#ffc300', 
            '600': '#e6b000', 
            '700': '#bf9200', 
            '800': '#997500', 
            '900': '#7d6000'
        }
    ,
    },
    config: {
        // Changing initialColorMode to 'dark'
        initialColorMode: 'light',
    },
    components: {
        Button: {
            // Can simply pass default props to change default behaviour of components.
            baseStyle: {
                rounded: 'md',
                p: '10'
            },
            defaultProps: {
                rounded: 'sm',
            },
        },
    }
});

export {
    theme
}